import {Component, Input, OnInit, OnDestroy, ViewChild} from '@angular/core';
import { ProjectService } from '../project/project.service';
import { Project } from '../model/project';
import {Report} from './report';
import {Respondent} from '../model/respondent';
import {ClickEvent} from '../project/pagination/pagination.component';
import {TranslateService} from '../translate/translate.service';
import {Json2TypescriptUtil} from '../util/json2TypescriptUtil';
import {ApplicationContext} from '../model/application-context';
import {Answer} from '../model/answer';
import {GenericModalComponent} from '../modal/generic-modal.component';
import {ReportFilterComponent} from '../reportFilter/reportFilter.component';
import {StringUtil} from '../util/stringUtil';


@Component({
    selector: 'reports',
    template:`
        <ng-container *ngIf="appContext.dataNavigationState.selectedView !=='quickLinkExcelReport'">
        <div id="reportHeader">
            <div class="grid-container">
                <div class="grid-item">
                    <table>
                        <tr>
                          <td>
                            <div class="w3-card-4">

                              <header class="w3-container w3-blue">
                                <h6>Project Name</h6>
                              </header>

                              <div class="w3-container">
                                <h4>{{_project.name}}</h4>
                              </div>
                              <footer class="w3-container w3-blue">
                                <h5></h5>
                              </footer>

                            </div>
                          </td>
                          <td>
                            <div class="w3-card-4">

                              <header class="w3-container w3-blue">
                                <h6>Project creation date</h6>
                              </header>

                              <div class="w3-container">
                                <h4 *ngIf="_project.createdDate!=null">{{formatDate(_project.createdDate)}}</h4>
                              </div>
                              <footer class="w3-container w3-blue">
                                <h5></h5>
                              </footer>

                            </div>
                          </td>

                          <td>
                            <div class="w3-card-4">

                              <header class="w3-container w3-blue">
                                <h6>Last Modified date</h6>
                              </header>

                              <div class="w3-container">
                                <h4 *ngIf="_project.lastModifiedDate!=null">{{formatDate(_project.lastModifiedDate)}}</h4>
                              </div>
                              <footer class="w3-container w3-blue">
                                <h5></h5>
                              </footer>

                            </div>
                          <td>
                            <div class="w3-card-4">

                              <header class="w3-container w3-blue">
                                <h6>Number of questions</h6>
                              </header>

                              <div class="w3-container">
                                <h4>{{this.appContext.questionnaire.questions.length}}</h4>
                              </div>
                              <footer class="w3-container w3-blue">
                                <h5></h5>
                              </footer>

                            </div>
                          </td>
                        </tr>
                        </table>
                </div>
                <div class="grid-item"></div>
                <div class="grid-item"></div>
                <div class="grid-item">
                    <table>
                        <tr>
                          <td>
                            <div class="w3-card-4">

                              <header class="w3-container w3-blue">
                                <h6>Number of Respondents</h6>
                              </header>

                              <div class="w3-container">
                                <h4>{{_nbOfRespondents}}</h4>
                              </div>
                              <footer class="w3-container w3-blue">
                                <h5></h5>
                              </footer>

                            </div>
                          </td>

                          <td>
                            <div class="w3-card-4">

                              <header class="w3-container w3-blue">
                                <h6>Number of Columns</h6>
                              </header>

                              <div class="w3-container">
                                <h4>{{_numberOfColumns}}</h4>
                              </div>
                              <footer class="w3-container w3-blue">
                                <h5></h5>
                              </footer>

                            </div>
                          </td>

                          <td>
                            <div class="w3-card-4">

                              <header class="w3-container w3-blue">
                                <h6>Size on Disk</h6>
                              </header>

                              <div class="w3-container">
                                <h4>{{_sizeOnDisk}}</h4>
                              </div>
                              <footer class="w3-container w3-blue">
                                <h5></h5>
                              </footer>

                            </div>
                          </td>
                        </tr>
                    </table>
                </div>
                <div class="grid-item"></div>
                <div class="grid-item"></div>
                <div class="grid-item"></div>
                <div class="grid-item"></div>
                <div class="grid-item"></div>
            </div>
    </div>
        <div id="reportHeader" class="searchFilter panel panel-default">
            <div class="card cardForm">
                <div class="card-header">
                    <h5><span><img alt="icon" class="titleBar" src="../../assets/images/087.png"></span>Search parameters</h5>
                </div>
            </div>
            <div class="card col-md-12">
                <div class="card-body">
            <table>
                <tr>
                    <div class="btn-group">
                        <button type="button" class="btn btn-primary">{{this.selectedDevice}}</button>
                        <button type="button" class="btn btn-primary dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <span class="sr-only">Toggle Dropdown</span>
                        </button>
                        <div class="dropdown-menu">
                            <a class="dropdown-item"  (click)="setFilterDevice(term)" *ngFor="let term of availablePhysicalDevices">{{term}}</a>
                        </div>
                    </div>
                </tr><tr>
                <div style="border: #00b0ff;border-width: medium;border-style: solid;margin-top: 10px;">
                    <label>Date Constraints</label>
                    <table>
                        <tr>
                            <td><label>Start Date</label></td>
                            <td><ejs-datepicker id='datepicker' placeholder='Select a date' [value]='dateValue' [min]='minDate' [max]='maxDate' (change)="startDateChanged($event)"></ejs-datepicker></td>
                        </tr>
                        <tr>
                            <td><label>End Date</label></td>
                            <td><ejs-datepicker id='datepicker' placeholder='Select a date' [value]='dateValue' [min]='minDate' [max]='maxDate' (change)="endDateChanged($event)"></ejs-datepicker></td>
                        </tr>
                    </table>

                    <button class="btn btn-primary" style="margin-left:5px;margin-bottom:5px;" (click)="resetDate()"> Reset Date</button>
                </div>
            </tr>
            <tr >
                <table style="margin-top:20px;">
                    <tr>
                        <div class="input-group mb-3">
                            <div class="input-group-prepend">
                                <span class="input-group-text" id="inputGroup-sizing-default">Search a specific answer</span>
                            </div>
                            <input type="text" class="form-control" aria-label="Default" aria-describedby="inputGroup-sizing-default"  [(ngModel)]="specificAnsFilter">
                        </div>
                    </tr>
                </table>
            </tr>
            <tr>
                    <div class="btn-group">
                        <button type="button" class="btn btn-primary">{{this.selectedTerminalId==0?'Filter By Terminal ID':this.selectedTerminalId}}</button>
                        <button type="button" class="btn btn-primary dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <span class="sr-only">Toggle Dropdown</span>
                        </button>
                        <div class="dropdown-menu">
                             <a class="dropdown-item"  *ngFor="let term of availableTerminals"  (click)="setFilterTerminalID(term)">{{term}}</a>
                        </div>
                    </div>
            </tr>
               <tr><Label>Avoid Test Respondents</Label><input type="checkbox" [checked]="avoidTestRespondent"></tr>
            </table>
            <button class="btn btn-primary" (click)="filterNow()">Filter</button>
        </div>
            </div>
        </div>

        <div class="tableContainer">
            <table id="respondentTable">
                <thead>
                    <tr>
                        <th class="dateColumn">Date</th>
                        <th>Hour</th>
                        <th>Respondent ID</th>
                        <th *ngFor="let question of this.appContext.questionnaire.questions">
                           {{question.texts.get(_translate.currentLang)}}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="entry" *ngFor="let resp of this.respondents">
                        <td>{{resp.insertedTime.substr(0,10)}}</td>
                        <td>{{resp.insertedTime.substr(11,resp.insertedTime.length)}}</td>
                        <td>{{resp.Id}}</td>
                        <ng-container *ngIf="this.appContext.questionnaire!=null">
                            <td *ngFor="let quest of this.appContext.questionnaire.questions">
                                <input [maxLength]="11" [disabled]="true" [value]="optimizeAnsLength(getAnswer(resp,quest.no))" data-toggle="tooltip" data-placement="bottom" [title]="getAnswer(resp,quest.no)">
                                <ng-container *ngIf="validatePath(getAnswer(resp,quest.no))">
                                    <img (click)="downloadImage(getAnswer(resp,quest.no))" alt="downloadIcon" class="downloadIcon" src="../../assets/images/downloads-icon.png"/>
                                </ng-container>
                            </td>
                        </ng-container>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="grid-container">
            <div class="grid-item"></div>
            <div class="grid-item">
                <div class="row">
                    <div class="paginationComponent">

                        <pagination
                                [item-can-change]="true"
                                [indexSelectedItem]="appContext.dataNavigationState.paginationNumber"
                                [item-by-page]="20"
                                [total-nb-respondents]="_nbOfRespondents"
                                (beforePageChange)="onBeforePageChange($event)"
                                (go)="onBeforePageChange($event)"></pagination>
                    </div>
                </div>
            </div>
            <div class="grid-item"></div>
        </div>
        </ng-container>
    <reportFilter [availablePhysicalDevices]="availablePhysicalDevices" [availableTerminals]="availableTerminals" [appContext]="appContext"></reportFilter>`,
    styles:[ `
        .header-container{background:linear-gradient(0deg,rgba(59,139,239,1) 0%,rgba(11,97,206,1) 100%);border-top-left-radius:5px;border-top-right-radius:5px;}
        h4.headerTitle{text-align: center;color:#ffffff;margin-top:20px;}
        .titleBar{height:26px;margin-right:5px;}
        .titleBarIcon{height:40px;}
        .subTitleBar{height:24px;margin-right:5px;}
        .card-header{ background-color:rgb(1,119,215);color:#ffffff;}
        .cardForm{margin-top:30px;border-color:#19A9E5;}
        .subHeader{height:40px;background-color:rgb(13,174,235);color:#ffffff;}

        input{width:70px;}
        .tableContainer{margin-top: 100px;padding:10px;}
        .entry:hover{ background-color : darkkhaki;}
        .dateColumn{width:150px;}
        th {
            padding-top: 12px;
            padding-bottom: 12px;
            text-align: center;
            background-color: seagreen;
            padding-left: 10px;
            padding-right: 10px;
            color: white;
            word-wrap:break-word;
            font-size: small;
            border-width: 3px;
            border-right-color: white;}
        tbody tr{height: 30px;}
        tbody tr td { font-size:small; text-align: center;}
        .emailColumn{width:200px;}
        #respondentTable tbody{
            overflow: auto;
            table-layout: fixed;
        }
        #respondentTable{width:100%}
        #respondentTable tbody tr:nth-child(even){ background-color: #66ff66}
        #respondentTable tbody tr:nth-child(odd){ background-color: #99ffcc}
        #reportHeader{
            border-radius: 10px;
            border-width: 4px;
            border-color: #19A9E5;
            width: 100%;
            background-color:rgba(25, 169, 229, 0.1);
        }

        .searchFilter{margin-top: 20px;}
        #reportHeader .grid-container {
            display: grid;
            grid-template-columns: auto auto auto;
            padding: 10px;
        }
        #reportHeader .grid-container .grid-item {
            padding: 20px;
            text-align: center;
        }
        #label{color:darkblue; font-family: Calibri;font-size: small}
        .paginationComponent{width:50%;margin:0 auto;}
        .grid-container {
            display: grid;
            grid-template-columns: auto auto auto;
            padding: 10px;
        }
        .grid-item {
            padding: 20px;
            text-align: center;
        }
        tbody tr:last-child td:first-child {border-bottom-left-radius: 5px;}
        tbody tr:last-child td:last-child {border-bottom-right-radius: 5px;}
        thead tr th:first-child{border-top-left-radius: 5px;}
        thead tr th:last-child{border-top-right-radius: 5px;}

        .entry:hover{ background-color: darkkhaki;font-size: large;}
    `]

})
export class ReportsComponent implements OnInit, OnDestroy {
    // @Input('questionnaire')questionnaire:Questionnaire;
    // @Input('synchros') synchros: Synchro[] = null;
    @Input('totalRespondent') _nbOfRespondents:number;
    // @Input('navigation-state') navigationState: DataNavigationState;
    @Input() appContext:ApplicationContext;

    @ViewChild (ReportFilterComponent) private reportFilterModal:ReportFilterComponent;

    original = false;
    transformed = false;
    notSend = false;

    report: Report;


    public minDate: Date = new Date ('01/01/1979');
    public maxDate: Date = new Date ('01/01/2100');
    public dateValue: Date = new Date (Date());



    private _numberOfColumns = 0;
    private _sizeOnDisk = 0;
    private _project = new Project();
    private _pageNumber = 1;

    private _errorMessage;

    private RESPONDENTS_BY_PAGE = 20;  // a remplacer par un input

    private respondents:Respondent[];



    private availableTerminals:string[];

    private availablePhysicalDevices:string[];

    private selectedDevice = 'Filter by Device';

    private selectedTerminalId = 0;

    private avoidTestRespondent = true;

    private specificAnsFilter:string;

    private startDate = ''; // milliseconds in string representation

    private endDate = ''; // milliseconds

    private filter = false;



    constructor(private _projectService: ProjectService,private _translate: TranslateService) {
    }

    private validatePath(str:string):boolean {
        return StringUtil.stringHasExtension(str);
    }

    ngOnInit() {

        // If we access excel reporting through quickLink
        if(this.appContext.dataNavigationState.selectedView === 'quickLinkExcelReport') {
            this.reportFilterModal.toggleFilter();
        }

        this._numberOfColumns = this.appContext.questionnaire.questions.length +8;

        this._projectService.getProject(sessionStorage.getItem('project_id')).subscribe(project => {

                this._project = Json2TypescriptUtil.getJsonConvertInstance().deserializeObject(project,Project);
            },
            error => this._errorMessage = <any>error);

        this.appContext.dataNavigationState.paginationNumber = this._pageNumber;

        this.navigateToPage(0);

    }

    ngOnDestroy() {

    }

    public showReportFilterModal() {
        this.reportFilterModal.toggleFilter();
    }


    private navigateToPage(pageNumber:number) {
        let startIndex:number = pageNumber;
        if(pageNumber!==0) {
            startIndex =  pageNumber-1;
        }
        startIndex = startIndex * this.RESPONDENTS_BY_PAGE;

        let endIndex:number;
        endIndex = startIndex+this.RESPONDENTS_BY_PAGE;


        // if(this.navigationState.paginationNumber != -1)
        // startIndex = this.navigationState.paginationNumber;
        // this.getRespondents((startIndex-1)*this.RESPONDENTS_BY_PAGE,this.RESPONDENTS_BY_PAGE);
        this.getRespondents(startIndex,this.RESPONDENTS_BY_PAGE);

    }

    onBeforePageChange($event:ClickEvent) {
         if ( $event.index >= 0  ) {
            this._pageNumber = $event.index;
            this.setRespondent();

            this.navigateToPage(this._pageNumber);


            // const startIndex = this._pageNumber -1;
            // this.getRespondents(startIndex,this.RESPONDENTS_BY_PAGE);
         }
    }

    setRespondent() {
        // this._activeRespondent = this._respondents[this._pageNumber - 1];
        // this._questionnaireUnchanged = QuestionnaireUtil.clone(this._activeRespondent.questionnaire);
        this.appContext.dataNavigationState.paginationNumber = this._pageNumber;
    }


    public prepareQuickLinkExcelReport() {
        this.getRespondents(0,this.RESPONDENTS_BY_PAGE);
    }

    public getAvailablePhysicalDevices():string[] {
        return this.availablePhysicalDevices;
    }

    public getAvailableTerminals():string[] {
        return this.availableTerminals;
    }

    private getRespondents(start:number,end:number) {

        this._projectService.getRespondentsByRange(start,end,-1,-1,-1,this.appContext.questionnaire.id,-1,false,this.startDate,this.endDate).subscribe((respondents) => {
                this.respondents = new Array<Respondent>();

                this.respondents = Json2TypescriptUtil.getJsonConvertInstance().deserializeArray(respondents,Respondent);

                console.log(this.respondents.length);

                const setDev = new Set();
                for(const resp of this.respondents) {
                    if(!setDev.has(resp.DeviceName)) {
                        setDev.add(resp.DeviceName);
                    }
                }

                this.availablePhysicalDevices = Array.from(setDev);

                const setTerminals = new Set();

                for(const resp of this.respondents) {
                    if(!setTerminals.has(resp.TerminalId)) {
                        setTerminals.add(resp.TerminalId);
                    }
                }

                this.availableTerminals = Array.from(setTerminals);

                if(this.respondents!=null && this.respondents.length>0) {
                  this._sizeOnDisk = this.respondents[0].sizeOnDisk * this._nbOfRespondents;
                }
                if(this.filter) {
                    this.filterRespondents();
                }

                /*for(let i = 0; i< respondents.length;i++) {
                  this.respondents.push(new Respondent(respondents[i]));
                }*/
            },
            error => this._errorMessage = <any>error);
    }

    private optimizeAnsLength(s: string) {
        if(s.length>10) {
            return s.substr(0,10);
        }
        return s;
    }

    private getAnswer(resp:Respondent,qNo:number): string {
        if(resp.getResponse(qNo)!= null) {
            return resp.getResponse(qNo).answer;
        }
        return  '';
    }

    private formatDate(str: string) {
        const date= new Date((Number(str))).toDateString();

        return date;
    }

    private addToArray(val:string,arr:string[]) {
        if(!arr.includes(val)) {
            arr.push(val);
        }
    }

    private filterNow() {

        this.navigateToPage(this._pageNumber);
        this.filter = true;


    }

    private filterRespondents() {
        if(this.selectedTerminalId!==0) {
            this.respondents = this.respondents.filter(p => p.TerminalId === Number(this.selectedTerminalId));
        }
        if(this.selectedDevice!=='Filter by Device') {
            this.respondents = this.respondents.filter(p => p.DeviceName === this.selectedDevice);
        }
        if(!this.avoidTestRespondent) {
            // test respondent
            // this.respondents = this.respondents.filter(p => p. === this.selectedDevice);
        }
        if(this.specificAnsFilter!=null && this.specificAnsFilter.length!==0) {
            // test respondent
            this.respondents = this.respondents.filter(p => this.isSpecificAnswerMatched(p.Answers));
        }
        this.filter = false;
    }

    private isSpecificAnswerMatched(listAns:Answer[]):Boolean {
        for(const ans of listAns) {
            if(ans.answer === this.specificAnsFilter) {
                return true;
            }
        }
        return false;
    }

    setFilterDevice(term: string) {
        this.selectedDevice = term;
    }

    startDateChanged($event:any) {
        console.log($event);
        this.startDate = $event.value.getTime().toString();
    }

    endDateChanged($event:any) {
        console.log($event);
        this.endDate = $event.value.getTime().toString();
    }

    setFilterTerminalID(terminalId: string) {
        this.selectedTerminalId = Number(terminalId);
    }

    resetDate() {
        this.startDate = '';
        this.endDate = '';
    }

    downloadImage(answer: string) {
        const str = answer.split('\\');
        const saveAs = require('file-saver');
        this._projectService.downloadContent(answer).subscribe((data)=> {
            saveAs.saveAs(data,str[str.length-1]);
        });
    }
}
